import { useNavigate } from 'react-router-dom';

import { Box, Stack, useTheme } from '@mui/material';
import Button from '@mui/material/Button';

import { useAppSelector } from '~system/store/configure-store';
import { selectActiveScope } from '~system/store/scope/scope-selectors';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { Logo } from '~components/ui/logo/logo';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useAppBack } from '~hooks/use-app-back';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconArrowLeftLg } from '~assets/icons/icon-arrow-left-lg.svg';
import { ReactComponent as IconHouse } from '~assets/icons/icon-building-1.svg';
import { ReactComponent as IconDashboard } from '~assets/icons/icon-dashboard.svg';

export const NotFoundPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const goBack = useAppBack();

  const activeScope = useAppSelector(selectActiveScope);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        padding: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: 480,
          height: 480,
          borderRadius: '50%',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background:
            'radial-gradient(circle, rgba(13,110,253,0.14), rgba(52,201,123,0.10), transparent 65%)',
          filter: 'blur(50px)',
          zIndex: 0,
        }}
      />

      <Stack
        alignItems={'center'}
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Stack direction={'row'} gap={1.5} sx={{ mb: 0.5 }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              background: `linear-gradient(45deg, ${theme.palette.primaryTokens['25']}, ${theme.palette.green['25']})`,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'neutral.100',
            }}
          >
            <AppIcon component={IconHouse} gradient gradientType={'3'} />
          </Box>
          <Stack mt={0.75}>
            <Logo width={130} height={40} />
          </Stack>
        </Stack>
        <AppTypography size={'body-sm'} color={'fog.35'} mb={4}>
          Управління орендою без хаосу
        </AppTypography>

        <AppTypography
          color={'fog.35'}
          sx={{
            fontSize: 120,
            background: 'linear-gradient(135deg, #0D6EFD 0%, #34C97B 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
          weight={'bold'}
        >
          404
        </AppTypography>

        <AppTypography size={'h5'} weight={'semibold'} color={'fog.35'} mb={2}>
          Сторінку не знайдено
        </AppTypography>

        <AppTypography size={'body-md'} color={'fog.35'} mb={4}>
          Можливо, адреса введена невірно або сторінка більше не існує
        </AppTypography>

        <Stack direction={'row'} gap={3}>
          <Button
            endIcon={<AppIcon component={IconDashboard} size={20} />}
            onClick={() => {
              if (activeScope === 'tenant') {
                navigate(ROUTES.TENANT_SCOPE);
                return;
              }

              navigate(ROUTES.DASHBOARD);
            }}
          >
            На головну
          </Button>

          <Button
            variant={'outlined'}
            startIcon={<AppIcon component={IconArrowLeftLg} size={20} />}
            onClick={goBack}
          >
            Назад
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
